var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C5.21 21 0.5 16.29 0.5 10.5C0.5 4.71 5.21 0 11 0C16.79 0 21.5 4.71 21.5 10.5C21.5 16.29 16.79 21 11 21ZM11 1.5C6.035 1.5 2 5.535 2 10.5C2 15.465 6.035 19.5 11 19.5C15.965 19.5 20 15.465 20 10.5C20 5.535 15.965 1.5 11 1.5Z",
    fill: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.e622a85069b9595be7a38896500b171a.svg";
export { ForwardRef as ReactComponent };